import React, { Component } from 'react';
import { Table, TableRow, TableCell, TableBody, TextField, TableFooter, Button, CircularProgress, FormControl, Card, Checkbox } from '@material-ui/core';
import withUser from '../HOC/HOCwithUser.jsx';
import HOCLoader from '../HOC/HOCLoader.jsx';
import Box from '@mui/material/Box';
import AddIcon from '@material-ui/icons/Add';
import { getStatus, ROLE_PROVIDER, SERVER_URL } from '../../utils/config/constants.js';
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category, RemoveCircle, } from '@material-ui/icons';

import moment from 'moment';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Image from 'react-bootstrap/Image';
import { NotificationManager } from 'react-notifications';
import Dropzone from 'react-dropzone';
import { getCookies } from '../../utils/getToken.js';
import Axios from 'axios';
import ReactCrop from 'react-image-crop';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import { HighlightOff } from '@material-ui/icons';
import { validateSignUpData } from '../../utils/validators/validateForm';
import uploadIcon from '../../assets/img/profile-upload-icon.png'

import { FormattedMessage, injectIntl } from 'react-intl';
import Datetime from 'react-datetime';
import TermsOfUseAlert from '../Alert/TermsOfUseAlert.jsx';
import AreYouSureAlert from '../Alert/AreYouSureAlert.jsx';
import { store } from '../../store'
import { Redirect } from 'react-router-dom';

const AdditionImagePicker = ({ title, handleDropRejected, handleDrop, userData, imageUploaded, front_imageId, noOfUpload = 1, onlyAdd = false }) => {
    return (
        <React.Fragment>
            {(() => {
                const arr = [];
                for (let i = 0; i < noOfUpload; i++) {
                    arr.push(
                        <div style={{
                        }}>
                            <Dropzone
                                onDrop={handleDrop}
                                accept="image/jpeg,image/jpg,image/png"
                                multiple={true}
                                maxSize={10485760}
                                onDropRejected={handleDropRejected}
                            >
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <Box > <Add fontSize='large' /></Box>
                                    </div>
                                )}
                            </Dropzone>
                        </div>
                    );
                }
                return arr;
            })()}
        </React.Fragment>
    );
}

const AddProfileImage = ({ title, handleDropRejected, handleDrop, userData, imageUploaded, front_imageId, noOfUpload = 1, onlyAdd = false }) => {
    return (
        <React.Fragment>
            {(() => {
                const arr = [];
                for (let i = 0; i < noOfUpload; i++) {
                    arr.push(
                        <div style={{ position: "absolute", top: "130px", left: "75px" }}>
                            <Dropzone
                                onDrop={handleDrop}
                                accept="image/jpeg,image/jpg,image/png"
                                multiple={true}
                                maxSize={10485760}
                                onDropRejected={handleDropRejected}
                            >
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <img src={uploadIcon} style={{ height: "25px" }} />

                                    </div>
                                )}
                            </Dropzone>
                        </div>
                    );
                }
                return arr;
            })()}
        </React.Fragment>
    );
}

const AddImagesBox = ({ title, handleDropRejected, handleDrop, userData, imageUploaded, imageId, noOfUpload = 1, onlyAdd = false, imgUrl, base64, isImgUploaded, uploadedImgLatest }) => {
    return (
        <React.Fragment>
            <Card sx={{ width: '100%', p: 3, flex: 1, alignItems: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}>
                        <Typography>{title}</Typography>
                        <Typography style={{ color: '#a432a8' }}>{`(*Allowed file size is 10MB and supports only JPEG/PNG)`}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 2, jutifyContent: 'center', pt: 2 }}>
                        {(() => {
                            const arr = [];
                            for (let i = 0; i < noOfUpload; i++) {
                                {
                                    imgUrl[i].split("/")[3] === 'images' ?
                                        <React.Fragment>
                                            {
                                                base64 ?
                                                    arr.push(
                                                        <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                            <p>11111</p>
                                                            <Dropzone
                                                                onDrop={handleDrop}
                                                                accept="image/jpeg,image/jpg,image/png"
                                                                multiple={true}
                                                                maxSize={10485760}
                                                                onDropRejected={handleDropRejected}
                                                            >
                                                                {({ getRootProps, getInputProps }) => (
                                                                    <div {...getRootProps()}>
                                                                        <input {...getInputProps()} />

                                                                        {
                                                                            base64 ?
                                                                                <Paper elevation={2}>
                                                                                    <p>2222</p>
                                                                                    <Image src={`data:image;base64,${base64}`} thumbnail style={{ width: 200, height: 120 }} />
                                                                                </Paper> :
                                                                                <Paper elevation={2}>
                                                                                    <p>3333</p>
                                                                                    <Image src={imgUrl[i]} thumbnail style={{ width: 200, height: 120 }} />
                                                                                </Paper>
                                                                        }

                                                                    </div>
                                                                )}
                                                            </Dropzone>
                                                        </div>
                                                    )
                                                    :
                                                    isImgUploaded ?
                                                        <div>
                                                            <p>heyyyyyyyyyy</p>
                                                            <Image src={uploadedImgLatest.url} style={{ width: 200, height: 120 }} />
                                                        </div>
                                                        : arr.push(
                                                            <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                                <p>4444</p>
                                                                <Dropzone
                                                                    onDrop={handleDrop}
                                                                    accept="image/jpeg,image/jpg,image/png"
                                                                    multiple={true}
                                                                    maxSize={10485760}
                                                                    onDropRejected={handleDropRejected}
                                                                >
                                                                    {({ getRootProps, getInputProps }) => (
                                                                        <div {...getRootProps()}>
                                                                            <input {...getInputProps()} />
                                                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 3, color: '#717175' }}>
                                                                                <Box > <AddIcon fontSize='large' /></Box>
                                                                                <Typography style={{ color: '#717175' }}>
                                                                                    Add Photo
                                                                                </Typography>
                                                                            </Box>
                                                                        </div>
                                                                    )}
                                                                </Dropzone>
                                                            </div>
                                                        )
                                            }
                                        </React.Fragment>



                                        :
                                        arr.push(
                                            <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                <Dropzone
                                                    onDrop={handleDrop}
                                                    accept="image/jpeg,image/jpg,image/png"
                                                    multiple={true}
                                                    maxSize={10485760}
                                                    onDropRejected={handleDropRejected}
                                                >
                                                    {({ getRootProps, getInputProps }) => (
                                                        <div {...getRootProps()}>
                                                            <input {...getInputProps()} />

                                                            {
                                                                base64 ?
                                                                    <Paper elevation={2}>
                                                                        <Image src={`data:image;base64,${base64}`} thumbnail style={{ width: 200, height: 120 }} />
                                                                    </Paper> :
                                                                    <Paper elevation={2}>
                                                                        <Image src={imgUrl[i]} thumbnail style={{ width: 200, height: 120 }} />
                                                                    </Paper>
                                                            }

                                                        </div>
                                                    )}
                                                </Dropzone>
                                            </div>
                                        )

                                }

                            }
                            return arr;
                        })()}
                    </Box>
                </Box>
            </Card>
        </React.Fragment>


    );
}



const handleDropRejected = (...args) => console.log('reject', args);
export class BasicCustomerProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isProofOfAddressUploaded: false,
            isCurrentInsuranceCrtificateUploaded: false,
            isCurrentBondUploaded: false,
            isContractorLicenseUploaded: false,
            termsConditionAgree: false,
            showTermOfUseAlert: false,
            profileImagebase64Data: null,
            email: '',
            fbLink: '',
            twLink: '',
            ytLink: '',
            instaLink: '',
            business_name: '',
            policy_number: '',
            contractor_number: '',
            est_date: '',
            exp_date: '',
            business_description: '',
            insurance_company_name: '',
            bank_name: '',
            bankError: '',
            account_holder_name: '',
            account_holder_nameerror: '',
            account_number: '',
            confirm_account_number: '',
            account_numbererror: '',
            rtn: '',
            rtnerror: '',
            showIdentity: false,
            provider_Type: '',
            crop: {
                aspect: 1 / 1
            },
            front_imageId: [],
            back_imageId: [],
            front_imageAdd: [],
            back_imageAdd: [],
            current_bondAdd: [],
            contractor_id: [],
            certificates: [],
            userUploadedCertificates: [],
            imageUploaded: false,
            imageAddCurrentUploaded: false,
            imageContractorIdUploaded: false,
            imageIdBackUploaded: false,
            imageAddFrontUploaded: false,
            imageAddBackUploaded: false,
            isCertificateUploaded: false,
            showSubmitForReviewBtn: true,
            buttonLoader: false,
            buttonSaveLoader: false,
            dob: "",
            openDateTime: false,
            ssn: "",
            driver_license: "",
            errors: {
                bank_name: "",
                account_holder_name: "",
                rtn: "",
                account_number: "",
                ssn: '',
                confirm_account_number: '',
            },
            fields: {
                bank_name: "",
                account_holder_name: "",
                rtn: "",
                account_number: "",
                ssn: '',
                confirm_account_number: '',
            },
            img_url_1: '',
            img_url_2: '',
            img_url_3: '',
            img_url_4: '',
            profileImagebase64Data1: null,
            profileImagebase64Data2: null,
            profileImagebase64Data3: null,
            profileImagebase64Data4: null,
            show_deactivate_alert: false,
            redirectMain: false,
        }
        this.handleDrop = this.handleDrop.bind(this);
        this.handleDropBack = this.handleDropBack.bind(this);
        this.handleFrontAddDrop = this.handleFrontAddDrop.bind(this);
        this.handleAddressDropBack = this.handleAddressDropBack.bind(this);
        this.handleCertificatDrop = this.handleCertificatDrop.bind(this);
        this.handleCurrentDropBack = this.handleCurrentDropBack.bind(this);
        this.handleContractorLicenseIdDrop = this.handleContractorLicenseIdDrop.bind(this);

        this.handleProfilePicDrop = this.handleProfilePicDrop.bind(this);

        this.handleImage1Drop = this.handleImage1Drop.bind(this)
        this.handleImage2Drop = this.handleImage2Drop.bind(this)
        this.handleImage3Drop = this.handleImage3Drop.bind(this)
        this.handleImage4Drop = this.handleImage4Drop.bind(this)

    }

    _handleReaderLoaded1 = e => {
        console.log("file uploaded 1: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data1: btoa(binaryString)
        });
    };
    _handleReaderLoaded2 = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data2: btoa(binaryString)
        });
    };
    _handleReaderLoaded3 = e => {
        console.log("file uploaded 3: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data3: btoa(binaryString)
        });
    };
    _handleReaderLoaded4 = e => {
        console.log("file uploaded 4: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data4: btoa(binaryString)
        });
    };

    handleImage1Drop(files) {
        console.warn("1CHOOSING FILE SHR", files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "address_front");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            ROLE_PROVIDER,
            this.onAdditionalImgDone
        )
    }

    handleImage2Drop(files) {
        console.warn("2CHOOSING FILE SHR", files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "address_back");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            ROLE_PROVIDER,
            this.onAdditionalImgDone2
        )
    }

    handleImage3Drop(files) {
        console.warn("3CHOOSING FILE SHR", files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded3.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "current_bond");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            ROLE_PROVIDER,
            this.onAdditionalImgDone3
        )
    }

    handleImage4Drop(files) {
        console.warn("4CHOOSING FILE SHR", files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded4.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "business_images");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            ROLE_PROVIDER,
            this.onAdditionalImgDone4
        )
    }

    onAdditionalImgDone = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_1: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    onAdditionalImgDone2 = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_2: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    onAdditionalImgDone3 = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_3: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    onAdditionalImgDone4 = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_4: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }


    handleImage1DropRejected = (...args) => console.log('reject', args);



    validate = (name, value) => {
        switch (name) {
            case "bank_name":
                if (!value) {
                    return "Bank name is Required";
                } else if (!value.match(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/)) {
                    return "Please enter valid Bank Name";
                } else {
                    return "";
                }
            case "account_holder_name":
                if (!value) {
                    return "Account Holder Name is Required";
                } else if (!value.match(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/)) {
                    return "Please enter valid Account Holder Name";
                } else {
                    return "";
                }

            case "rtn":
                if (!value) {
                    return "RTN is Required";
                }


                else if (value.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/)) {
                    return "Please enter valid  RTN";
                }


                else {
                    return "";
                }

            case "account_number":
                if (!value) {
                    return "Account Number is Required";
                }

                else if (value.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/)) {
                    return "Please enter valid Account Number";
                }

                else {
                    return "";
                }

            case "ssn":
                if (!value) {
                    return "SSN is Required";
                } else if (value.length > 9) {
                    return "Please insert valid SSN Number ";
                }


                else if (value.length > 9) {
                    return "Please insert valid SSN Number";
                }
                else if (!value.match(/[0-9]/g)) {
                    return "Please enter at least one digit.";
                } else {
                    return "";
                }
            default: {
                return "";
            }
        }
    }

    handleSubmit = e => {
        const { error } = this.state;
        let validationErrors = {};
        Object.keys(this.state).forEach(name => {
            const error = this.validate(name, this.state[name]);
            if (error && error.length > 0) {
                validationErrors[name] = error;

            }
        });
        if (Object.keys(validationErrors).length > 0) {
            this.setState({ errors: validationErrors });

            NotificationManager.error(
                "Please Enter  Bank and SSN  Details",
            );
            return;
        }
        if (this.state.rtn && this.state.bank_name && this.state.account_number && this.state.account_holder_name && this.state.ssn) {
            const data = {
                rtn: this.state.rtn,
                account_holder_name: this.state.account_holder_name,
                account_number: this.state.account_number,
                bank_name: this.state.bank_name,
                ssn: this.state.ssn,
            };
            console.log("----data----", data);
        }

    };


    getData = () => {
        console.log("Inside GetData certifications", this.props.userData)
        const { userData } = this.props;
        this.setState({
            fbLink: userData.fb_link,
            twLink: userData.twitter_link,
            ytLink: userData.youtube_link,
            instaLink: userData.insta_link,
            business_name: userData.businessName,
            policy_number: userData.policy_no,
            contractor_number: userData.contractor_no,
            est_date: userData.establishedOn,
            exp_date: userData.expiry_date,
            business_description: userData.description,
            insurance_company_name: userData.insurance_company_name,
            bank_name: userData.bank_name,
            account_holder_name: userData.account_holder_name,
            account_number: userData.account_number,
            confirm_account_number: userData.account_number,
            rtn: userData.rtn,
            provider_Type: userData.account_type,
            userUploadedCertificates: userData.certifications,
            dob: userData.dob,
            ssn: userData.ssn,
            driver_license: userData.driver_license,
            email: userData.email,
        })
        if (userData.role === ROLE_PROVIDER) {
            this.setState({
                idProofFront: this.props.userData.identity_front.small.includes("default")
                    ? ""
                    : this.props.userData.identity_front.small,
                idProofBack: this.props.userData.identity_back.small.includes("default")
                    ? ""
                    : this.props.userData.identity_back.small,
                AddressFront: this.props.userData.address_front.small.includes("default")
                    ? ""
                    : this.props.userData.address_front.small,
                AddressBack: this.props.userData.address_back.small.includes("default")
                    ? ""
                    : this.props.userData.address_back.small,
                currentBond: this.props.userData.current_bond.small.includes("default")
                    ? ""
                    : this.props.userData.current_bond.small,
                businessImages: this.props.userData.business_images.length > 0
                    ? this.props.userData.business_images[0].small.includes("default")
                        ? ""
                        : this.props.userData.business_images[0].small : '',
            })
        }

    }
    componentDidMount() {
        this.getData()
    }

    handleDrop(files) {

        var fData = new FormData()
        fData.append('attribute', "identity_front");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            ROLE_PROVIDER,
            this.onFrontIdDone
        )
    }

    onFrontIdDone = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            this.setState({
                front_imageId: data.data,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)
            })
        } else {
            this.setState({
                front_imageId: [],
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    handleDropBack(files) {
        var fData = new FormData()
        fData.append('attribute', "identity_back");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            ROLE_PROVIDER,
            this.onBackIdDone
        )
    }

    onBackIdDone = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            this.setState({
                back_imageId: data.data,
                imageIdBackUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)
            })
        } else {
            this.setState({
                back_imageId: [],
                imageIdBackUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }


    handleFrontAddDrop(files) {
        var fData = new FormData()
        fData.append('attribute', "address_front");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            ROLE_PROVIDER,
            this.onAdditionalImgDone
        )
    }


    onFrontAddDone = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            this.setState({
                front_imageAdd: data.data,
                imageAddFrontUploaded: true,
                isProofOfAddressUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)
            })
        } else {
            this.setState({
                front_imageAdd: [],
                imageAddFrontUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }


    handleAddressDropBack(files) {
        var fData = new FormData()
        fData.append('attribute', "address_back");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            ROLE_PROVIDER,
            this.onBackAddDone
        )

    }

    onCurrentAddDone = (success, data) => {
        console.log("success, data,files ", success, data)
        if (success) {
            this.setState({
                current_bondAdd: data.data,
                imageAddCurrentUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)
            })
        } else {
            this.setState({
                current_bondAdd: [],
                imageAddCurrentUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }
    onContractorIdDone = (success, data) => {
        console.log("success, data,files ", success, data)
        if (success) {
            this.setState({
                contractor_id: data.data,
                imageContractorIdUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)
            })
        } else {
            this.setState({
                contractor_id: [],
                imageContractorIdUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }
    handleCurrentDropBack(files) {
        console.log("handleCurrentDropBack", files)
        var fData = new FormData()
        fData.append('attribute', "current_bond");
        fData.append('image', files[0])
        this.props.idActionUpload(fData, ROLE_PROVIDER, this.onCurrentAddDone)
    }

    handleContractorLicenseIdDrop(files) {
        console.log("handleContractorLicenseIdDrop", files)
        var fData = new FormData()
        fData.append('attribute', "business_images");
        fData.append('image', files[0])
        this.props.idActionUpload(fData, ROLE_PROVIDER, this.onContractorIdDone)
    }

    onBackAddDone = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            this.setState({
                back_imageAdd: data.data,
                imageAddBackUploaded: true,
                isCurrentInsuranceCrtificateUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)
            })
        } else {
            this.setState({
                back_imageAdd: [],
                imageAddBackUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    handleCertificatDrop(files) {
        this.setState({
            certificates: this.state.certificates.concat(
                files.map(file =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    }))
            )
        })
        var fData = new FormData()
        fData.append('attribute', "business_images");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            ROLE_PROVIDER,
            this.onCertificateAdded
        )
    }

    onCertificateAdded = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            NotificationManager.success("Success", data.message)
            var newImageItem = {
                'small': data.data.url,
                'medium': data.data.url,
                'large': data.data.url,
            }
            this.setState({
                userUploadedCertificates: [...this.state.userUploadedCertificates, newImageItem],
                certificates: []
            })
        } else {
            NotificationManager.error("Oops!", data)
            this.setState({
                certificates: []
            })
        }
    }

    removeImage = (uri) => {
        var authToken = getCookies();
        Axios({
            method: 'post', //you can set what request you want to be
            url: `${SERVER_URL}/provider/remove-certification`,
            headers: {
                'x-auth-Token': authToken
            },
            data: { url: uri },
        }).then((response) => {
            if (response.data.status == 'OK') {
                NotificationManager.success("Success", response.data.message)
                var newUserCertificates = this.state.userUploadedCertificates.filter(image => image.small !== uri);
                this.setState({ userUploadedCertificates: newUserCertificates })
            } else {
                NotificationManager.error("Oops!", response.data.message)
            }
        })
    }

    submitProfileNew = () => {
        this.setState({
            buttonSaveLoader: false
        }
        );
        var authToken = getCookies();
        Axios({
            method: 'get',
            url: `${SERVER_URL}/profile/submit`,

            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            console.log("submit daataa", resJson)
            if (resJson.data.status == "OK") {
                window.location.reload()
                console.log("daataaddddddddddddddddd", this.state.dob)
                NotificationManager.success("Success", resJson.data.message)
                this.setState({
                    buttonSaveLoader: false
                })
            } else {
                NotificationManager.error("Oops!", resJson.data.message)
                this.setState({
                    buttonSaveLoader: false
                })
            }
        })

    }

    updateProfile = () => {
        this.setState({
            buttonSaveLoader: false
        }
        );
        var authToken = getCookies();
        Axios({
            method: 'post',
            data: {

                establishedOn: this.state.est_date,
                insurance_company_name: this.state.insurance_company_name.toUpperCase(),
                policy_no: this.state.policy_number.toUpperCase(),
                contractor_no: this.state.contractor_number.toUpperCase(),
                expiry_date: this.state.exp_date,
                description: this.state.business_description
            },
            url: `${SERVER_URL}/provider/update-profile`,

            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            console.log("daataa", resJson)
            if (resJson.data.status == "OK") {
                this.setState({
                    buttonSaveLoader: false
                })
                NotificationManager.success("Success", resJson.data.message)
            } else {
                NotificationManager.error("Oops!", resJson.data.message)
                this.setState({
                    buttonSaveLoader: false

                })

            }
        })

    }

    onProfileStatus = () => {
        this.setState({
            buttonLoader: true
        })
        var authToken = getCookies();
        Axios({
            method: 'get',
            url: `${SERVER_URL}/profile/submit`,
            headers: {
                'x-auth-Token': authToken
            },
        }).then(async (Response) => {
            console.log('Profile status response========a', Response, Response.data.status)
            if (Response.data.status == 'OK') {
                NotificationManager.success("Success", Response.data.message)
                const response = await this.props.getLoggedInUserAction();
                if (response) {
                    this.setState({
                        buttonLoader: false
                    })
                } else {
                    this.setState({
                        buttonLoader: false
                    })
                }

            } else {
                NotificationManager.error("Oops!", Response.data.message)
                this.setState({
                    buttonLoader: false
                })
            }
        })
    }

    onFromChangeDate = event => {
        const dateTimeValue = moment(event).format('MM/DD/YYYY');
        this.setState({ dob: dateTimeValue, openDateTime: false })
    }

    changeNum(num) {
        var formatNum = num.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
        this.setState({
            ssn: formatNum
        }, console.log("number", formatNum));
    }

    handleDropRejected = (...args) => console.log('reject', args);

    _handleReaderLoaded = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data: btoa(binaryString)
        });
    };

    handleProfilePicDrop(files) {
        console.log("handleProfilePicDrop", file)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "logo");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            ROLE_PROVIDER,
            this.onProfilePicDone
        )
    }

    onFromChangeDateExp = event => {
        const dateTimeValue = moment(event).format('MM/DD/YYYY');
        this.setState({ exp_date: dateTimeValue, openDateTime: false })
    }

    onFromChangeDateEst = event => {
        const dateTimeValue = moment(event).format('MM/DD/YYYY');
        this.setState({ est_date: dateTimeValue, openDateTime: false })
    }

    handleRefreshClick = () => {
        window.location.reload();
    };

    openModel = () => {
        //console.log("state", this.state);
        this.setState({ show_deactivate_alert: true })
    }
    deactivate = async () => {
        this.props.deactivateAction(
            {
                role: store.getState().auth.userData.role
            },
            this.onDone
        );
    }

    onDone = (success, data) => {
        if (success) {
            console.log(data)
            this.setState({
                //redirectMain: true,
                show_deactivate_alert: false
            });
            this.props.history.push('/');
        }
    };
    
    

    render() {

        var fromMax = moment().add(0, 'day')

        var valid = function (current) {

            return (fromMax >= current);
        };


        var yesterday = moment().subtract(1, 'day');
        var validexdate = function (current) {

            return current.isAfter(yesterday);
        };

        const { bankError,
            rtnerror,
            account_holder_nameerror,
            account_numbererror, formErrors } = this.state;
        const { userData } = this.props;
        console.log("USERDATA AAAAAA", userData);
        const { fields, errors, AddressFront, AddressBack, } = this.state;
        const initialValues = {
            rtn: '',
        };

        return (
            <HOCLoader loading={this.props.isLoading}>
                <div className="text-center arab-table tz-db-table">
                    {userData.role == ROLE_PROVIDER && !userData.show_underreview && !userData.rejected && !userData.approved &&
                        <div className="d-flex justify-content-center p-2 md-12" style={{
                            borderWidth: 1, borderStyle: "solid", borderColor: "#dddddd", height: 50,
                            alignItems: "center", flexDirection: "column"
                        }}>
                            <Typography style={{ fontWeight: "bold", color: 'blue', fontSize: 20 }} >Your profile is in progress</Typography>
                            <Typography style={{ fontWeight: 'normal', color: 'gray', fontSize: 15 }} >Please complete your profile and submit for approval</Typography>

                        </div>}
                    {userData.role == ROLE_PROVIDER && userData.show_underreview &&
                        <div className="d-flex justify-content-center p-2 md-12" style={{
                            borderWidth: 1, borderStyle: "solid", borderColor: "#dddddd", height: 50,
                            alignItems: "center", flexDirection: 'column'
                        }}>
                            <Typography style={{ fontWeight: "bold", color: '#e1e123', fontSize: 20 }} >Your profile is under review.</Typography>
                            <Typography style={{ fontWeight: 'normal', color: 'gray', fontSize: 15 }} >To check your updated profile status,
                                <span onClick={this.handleRefreshClick}
                                    style={{ cursor: 'pointer', fontWeight: 'bold', color: 'blue', fontSize: 15 }}
                                >&nbsp; Click Here</span>
                            </Typography>

                        </div>}
                    {userData.role == ROLE_PROVIDER && userData.rejected &&
                        <div className="d-flex justify-content-center p-2 md-12" style={{
                            borderWidth: 1, borderStyle: "solid", borderColor: "#dddddd", height: 50,
                            alignItems: "center", flexDirection: "column"
                        }}>
                            <Typography style={{ fontWeight: "bold", color: 'red', fontSize: 20 }} >Your profile is Rejected.</Typography>
                            <Typography style={{ fontWeight: 'normal', color: 'gray', fontSize: 15 }} >Please provide requested details and resubmit your profile</Typography>
                        </div>}

                    {
                        userData.role != ROLE_PROVIDER &&
                        <div>
                            <div className='ds-boar-title' style={{ marginTop: 10, marginBottom: 20, display: "flex", justifyContent: "space-between" }}>
                                <h2 style={{
                                    textAlign: 'start',
                                }}>
                                    <FormattedMessage
                                        id="user.basicInfo"
                                        defaultMessage="Basic Info 11"
                                    />
                                </h2>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        // backgroundColor: '#0078ff',
                                        width: '40%',
                                        margin: '4px 4px',
                                        borderRadius: 5,
                                        cursor: 'pointer'
                                    }}
                                    onClick={this.openModel}

                                >
                                    <RemoveCircle style={{ marginTop: 10 }} />
                                    <p style={{
                                        marginBottom: 0,
                                        padding: 10,
                                        color: 'red',
                                        fontSize: 17
                                    }}>Delete Account</p>
                                </div>
                            </div>
                            <Table className="table borderless custom-input-text">
                                <TableBody>
                                    <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="name"
                                                defaultMessage="Name"
                                            />
                                            :
                                        </TableCell>
                                        <TableCell className="text-left">
                                            {userData.name}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="email"
                                                defaultMessage="Email"
                                            />
                                            :
                                        </TableCell>
                                        <TableCell className="text-left">
                                            {userData.email}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="phone"
                                                defaultMessage="Phone"
                                            />{' '}
                                            :
                                        </TableCell>
                                        <TableCell className="text-left">
                                            {userData.phone}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </div>
                    }

                    {
                        userData.role == ROLE_PROVIDER &&
                        <ExpansionPanel
                            defaultExpanded={true}
                        >
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <p style={{
                                    marginBottom: 0,
                                    fontSize: 15,
                                    fontWeight: 'bold',
                                }}>Basic Info</p>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>

                                <Table className="table borderless custom-input-text">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell className="text-left">
                                                <FormattedMessage
                                                    id="name"
                                                    defaultMessage="Name"
                                                />
                                                :
                                            </TableCell>
                                            <TableCell className="text-left">
                                                {userData.name}
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell className="text-left">
                                                <FormattedMessage
                                                    id="email"
                                                    defaultMessage="Email"
                                                />
                                                :
                                            </TableCell>
                                            <TableCell className="text-left">
                                                {userData.email}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className="text-left">
                                                <FormattedMessage
                                                    id="phone"
                                                    defaultMessage="Phone"
                                                />{' '}
                                                :
                                            </TableCell>
                                            <TableCell className="text-left">
                                                {userData.phone}
                                            </TableCell>
                                        </TableRow>

                                    </TableBody>
                                </Table>

                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    }


                    {userData.role == ROLE_PROVIDER && userData.account_type == 2 && (
                        <div>
                            <ExpansionPanel
                                defaultExpanded={true}
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-start'
                                    }}>
                                        <p style={{
                                            marginBottom: 0,
                                            fontSize: 15,
                                            fontWeight: 'bold',
                                            //color: 'black'
                                        }}>About Business</p>
                                    </div>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Box width='100%'>
                                        <Grid container spacing={2}>

                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                borderRadius: '10px',
                                                width: '100%',
                                                marginBottom: 20
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-evenly',
                                                }}>
                                                    <div style={{
                                                        border: '1px solid #eee',
                                                        width: '50%',
                                                        padding: 10,
                                                    }}>
                                                        <p>Proof of Business Address</p>
                                                        <p style={{ color: 'red', fontSize: 12 }}>(*Allowed file size is 10MB and supports only JPEG/PNG)</p>
                                                        {
                                                            AddressFront !== ''
                                                                ? <img
                                                                    src={this.props.userData.address_front.small}
                                                                    style={{ margin: '10px 0', height: '10rem', width: '10rem', borderRadius: 10 }} />
                                                                : (
                                                                    this.state.img_url_1
                                                                        ?
                                                                        <img
                                                                            src={this.state.profileImagebase64Data1 ?
                                                                                `data:image;base64,${this.state.profileImagebase64Data1}` : this.state.img_url_1}
                                                                            style={{ margin: '10px 0', height: '10rem', width: '10rem', borderRadius: 10 }} />
                                                                        : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>
                                                                            <AdditionImagePicker
                                                                                handleDrop={this.handleImage1Drop}
                                                                                handleDropRejected={this.handleImage1DropRejected}
                                                                                userData={this.props.userData}
                                                                                state={this.state}
                                                                                imageUploaded={this.state.imageUploaded}
                                                                                noOfUpload={1}
                                                                            />
                                                                            <Typography style={{ color: '#717175' }}>
                                                                                Add Photo 1
                                                                            </Typography>
                                                                        </Box>
                                                                )
                                                        }
                                                    </div>
                                                    <div style={{
                                                        border: '1px solid #eee',
                                                        width: '50%',
                                                        padding: 10,
                                                    }}>
                                                        <p>Current Insurance Certificate</p>
                                                        <p style={{ color: 'red', fontSize: 12 }}>(*Allowed file size is 10MB and supports only JPEG/PNG)</p>
                                                        {
                                                            this.state.AddressBack !== ''
                                                                ? <img
                                                                    src={this.props.userData.address_back.small}
                                                                    style={{ margin: '10px 0', height: '10rem', width: '10rem', borderRadius: 10 }} />
                                                                :
                                                                this.state.img_url_2
                                                                    ?
                                                                    <img
                                                                        src={this.state.profileImagebase64Data2 ?
                                                                            `data:image;base64,${this.state.profileImagebase64Data2}` : this.state.img_url_2}
                                                                        style={{ margin: '10px 0', height: '10rem', width: '10rem', borderRadius: 10 }} />
                                                                    : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>
                                                                        <AdditionImagePicker
                                                                            handleDrop={this.handleImage2Drop}
                                                                            handleDropRejected={this.handleImage1DropRejected}
                                                                            userData={this.props.userData}
                                                                            state={this.state}
                                                                            imageUploaded={this.state.imageUploaded}
                                                                            noOfUpload={1}
                                                                        />
                                                                        <Typography style={{ color: '#717175' }}>
                                                                            Add Photo 2
                                                                        </Typography>
                                                                    </Box>
                                                        }
                                                    </div>
                                                </div>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-evenly',
                                                }}>
                                                    <div style={{
                                                        border: '1px solid #eee',
                                                        width: '50%',
                                                        padding: 10,
                                                    }}>
                                                        <p>Current Bond</p>
                                                        <p style={{ color: 'red', fontSize: 12 }}>(*Allowed file size is 10MB and supports only JPEG/PNG)</p>
                                                        {
                                                            this.state.currentBond !== ''
                                                                ?
                                                                <img
                                                                    src={this.props.userData.current_bond.small}
                                                                    style={{ margin: '10px 0', height: '10rem', width: '10rem', borderRadius: 10 }} />
                                                                :
                                                                this.state.img_url_3
                                                                    ?
                                                                    <img
                                                                        src={this.state.profileImagebase64Data3 ?
                                                                            `data:image;base64,${this.state.profileImagebase64Data3}` : this.state.img_url_3}
                                                                        style={{ margin: '10px 0', height: '10rem', width: '10rem', borderRadius: 10 }} />
                                                                    : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>
                                                                        <AdditionImagePicker
                                                                            handleDrop={this.handleImage3Drop}
                                                                            handleDropRejected={this.handleImage1DropRejected}
                                                                            userData={this.props.userData}
                                                                            state={this.state}
                                                                            imageUploaded={this.state.imageUploaded}
                                                                            noOfUpload={1}
                                                                        />
                                                                        <Typography style={{ color: '#717175' }}>
                                                                            Add Photo 3
                                                                        </Typography>
                                                                    </Box>
                                                        }
                                                    </div>
                                                    <div style={{
                                                        border: '1px solid #eee',
                                                        width: '50%',
                                                        padding: 10,
                                                    }}>
                                                        <p>Contractor License ID</p>
                                                        <p style={{ color: 'red', fontSize: 12 }}>(*Allowed file size is 10MB and supports only JPEG/PNG)</p>
                                                        {
                                                            this.state.businessImages !== ''
                                                                ?
                                                                <img

                                                                    src={this.state.businessImages}
                                                                    style={{ margin: '10px 0', height: '10rem', width: '10rem', borderRadius: 10 }} />
                                                                :
                                                                this.state.img_url_4
                                                                    ?
                                                                    <img

                                                                        src={this.state.profileImagebase64Data4 ?
                                                                            `data:image;base64,${this.state.profileImagebase64Data4}` : this.state.img_url_4}
                                                                        style={{ margin: '10px 0', height: '10rem', width: '10rem', borderRadius: 10 }} />

                                                                    : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>

                                                                        <AdditionImagePicker
                                                                            handleDrop={this.handleImage4Drop}
                                                                            handleDropRejected={this.handleImage1DropRejected}
                                                                            userData={this.props.userData}
                                                                            state={this.state}
                                                                            imageUploaded={this.state.imageUploaded}
                                                                            noOfUpload={1}
                                                                        />
                                                                        <Typography style={{ color: '#717175' }}>
                                                                            Add Photo 4
                                                                        </Typography>
                                                                    </Box>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <Grid container xs={12}>

                                                <Table className="table bordered custom-input-text">
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="contractor_no"
                                                                    defaultMessage="Contract License Number"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left">
                                                                <form className="form-new">
                                                                    <TextField
                                                                        className="login-form-textfield"
                                                                        id="contractor_no"
                                                                        fullWidth={true}
                                                                        label="Contractor License Number"
                                                                        type="text"
                                                                        name="contractor_no"
                                                                        placeholder="Enter Contractor License Number"
                                                                        value={this.state.contractor_number}
                                                                        onChange={(event) => {
                                                                            this.setState({
                                                                                contractor_number: event.target.value,
                                                                            });
                                                                        }}
                                                                        disabled={userData.approved && userData.disable_sensitive_info || userData.show_underreview}
                                                                    />

                                                                </form>
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="establishedOn"
                                                                    defaultMessage="Date of Establishment"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left ">
                                                                <div style={{ backgroundColor: "white", px: -5, marginTop: 10, marginBottom: 28 }} className="col-md-12 custom-input-text dod">

                                                                    <form className="form-new">
                                                                        <FormControl
                                                                            fullWidth
                                                                            sx={{ marginLeft: '-17px' }}
                                                                            className="login-form-textfield dateof"
                                                                        >
                                                                            <Datetime
                                                                                open={
                                                                                    this.state
                                                                                        .openDateTime
                                                                                }
                                                                                viewDate={moment().format('MM/DD/YYYY')}
                                                                                format={"MM/DD/YYYY"}
                                                                                isValidDate={valid}
                                                                                timeFormat={false}
                                                                                onChange={
                                                                                    this.onFromChangeDateEst
                                                                                }
                                                                                value={
                                                                                    this.state.est_date
                                                                                }
                                                                                inputProps={{
                                                                                    placeholder: this.props.intl.formatMessage(
                                                                                        {
                                                                                            id: 'establishedOn',
                                                                                            defaultMessage: "Date of Establishment"

                                                                                        }

                                                                                    )
                                                                                }}
                                                                                dob={"Date of Establishment"}
                                                                            />
                                                                        </FormControl>
                                                                    </form></div>
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="insurance_company_name"
                                                                    defaultMessage="Insurance Company Name"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left ">
                                                                <form className="form-new">
                                                                    <TextField
                                                                        disabled={userData.approved && userData.disable_sensitive_info || userData.show_underreview}
                                                                        className="login-form-textfield"
                                                                        id="inscompnyname"
                                                                        label="Insurance Company Name"
                                                                        fullWidth={true}
                                                                        name="inscompnyname"
                                                                        placeholder={"Enter Insurance Company Name"}
                                                                        value={this.state.insurance_company_name}
                                                                        onChange={event => {
                                                                            this.setState({
                                                                                insurance_company_name: event.target.value,
                                                                            });
                                                                        }}
                                                                    />
                                                                </form>

                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="policy_no"
                                                                    defaultMessage="Policy Number"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left">
                                                                <form className="form-new">
                                                                    <TextField
                                                                        className="login-form-textfield"
                                                                        id="policyno"
                                                                        label="Policy Number"

                                                                        fullWidth={true}
                                                                        name="policyno"
                                                                        placeholder={"Enter Policy Number"}
                                                                        value={this.state.policy_number}
                                                                        onChange={event => {
                                                                            this.setState({
                                                                                policy_number: event.target.value,
                                                                            });
                                                                        }}
                                                                        disabled={userData.approved && userData.disable_sensitive_info || userData.show_underreview}
                                                                    />
                                                                </form>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="expiry_date"
                                                                    defaultMessage="Date of Expiration"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left ">
                                                                <div style={{ backgroundColor: "white", marginTop: 10, marginBottom: 28 }} className="col-md-12 custom-input-text dod">

                                                                    <form className="form-new">
                                                                        <FormControl
                                                                            sx={{ marginLeft: '-17px' }}
                                                                            fullWidth
                                                                            className="login-form-textfield "
                                                                        >
                                                                            <Datetime

                                                                                open={
                                                                                    this.state
                                                                                        .openDateTime
                                                                                }
                                                                                viewDate={moment().format('MM/DD/YYYY')}
                                                                                format={"MM/DD/YYYY"}
                                                                                isValidDate={validexdate}
                                                                                timeFormat={false}
                                                                                onChange={
                                                                                    this.onFromChangeDateExp
                                                                                }
                                                                                value={
                                                                                    this.state.exp_date
                                                                                }


                                                                                inputProps={{
                                                                                    placeholder: this.props.intl.formatMessage(
                                                                                        {
                                                                                            id: 'expiry_date',
                                                                                            defaultMessage: "Date of Expiration"

                                                                                        }

                                                                                    )

                                                                                }}
                                                                                dob={"Date of Expiration"}


                                                                            />
                                                                        </FormControl>
                                                                    </form></div>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="Notes (If any)"
                                                                    defaultMessage="Notes (If any)"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left">
                                                                <form className="form-new">
                                                                    <TextField
                                                                        className="login-form-textfield"
                                                                        id="Notes"
                                                                        label="Notes"

                                                                        fullWidth={true}
                                                                        name="Notes (If any)"
                                                                        placeholder={"Enter Notes"}
                                                                        value={this.state.business_description}
                                                                        onChange={event => {
                                                                            this.setState({
                                                                                business_description: event.target.value,
                                                                            });
                                                                        }}

                                                                    />
                                                                </form>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                                <div
                                                    onClick={this.updateProfile}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        backgroundColor: '#0078ff',
                                                        width: '100%',
                                                        margin: '20px 100px',
                                                        borderRadius: 5,
                                                        cursor: 'pointer'
                                                    }}>
                                                    <p style={{
                                                        marginBottom: 0,
                                                        padding: 10,
                                                        color: 'white',
                                                        fontSize: 17
                                                    }}>Save</p>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </div>
                    )}
                    {/** About Business end**/}
                    <div style={{
                        margin: '20px 5px',
                        textAlign: 'left'
                    }}>
                        {
                            userData.role == ROLE_PROVIDER &&
                            <p>Please contact admin and share ID proofs & Bank details</p>
                        }
                        {
                            (userData.role == ROLE_PROVIDER && !userData.show_underreview && !userData.approved) &&
                            <div style={{
                                display: 'flex',
                                jutifyContent: 'center',
                                alignItems: 'center',
                                margin: '0 -15px'
                            }}
                            >
                                <Checkbox
                                    checked={this.state.termsConditionAgree}
                                    onChange={() => this.setState({
                                        termsConditionAgree: !this.state.termsConditionAgree
                                    })}
                                    value="is_default"
                                    color="primary"
                                />
                                <p
                                    style={{
                                        margin: 0
                                    }}>I agree to ezPro <span
                                        onClick={() => this.setState({
                                            showTermOfUseAlert: true
                                        })}
                                        style={{ color: '#0078ff', textDecoration: 'underline', cursor: 'pointer' }}>Terms and Conditions</span></p>
                            </div>
                        }
                    </div>
                    {userData.role == ROLE_PROVIDER && !userData.show_underreview && !userData.rejected && !userData.approved && (
                        <div className="md-12">
                            <div className="col-md-12 d-flex" style={{ justifyContent: "center" }}>
                                {this.state.buttonSaveLoader ? <CircularProgress /> :
                                    <button
                                        className="custom-button"
                                        onClick={() => this.state.termsConditionAgree ? this.submitProfileNew() : NotificationManager.error('Please accept Terms & Conditions')}
                                    >
                                        {/* SAVE CHANGES */}
                                        SUBMIT FOR APPROVAL
                                    </button>}
                            </div>

                        </div>
                    )}

                    {userData.role == ROLE_PROVIDER && userData.rejected && (
                        <div className="md-12">
                            <div className="col-md-12 d-flex" style={{ justifyContent: "center" }}>
                                {this.state.buttonSaveLoader ? <CircularProgress /> :
                                    <button
                                        className="custom-button"
                                        onClick={() => this.state.termsConditionAgree ? this.submitProfileNew() : NotificationManager.error('Please accept Terms & Conditions')}
                                    >
                                        {/* SAVE CHANGES */}
                                        RE-SUBMIT FOR APPROVAL
                                    </button>}
                            </div>
                        </div>
                    )}
                </div>
                <TermsOfUseAlert
                    open={this.state.showTermOfUseAlert}
                    title=""
                    content="By accepting this you agree with the adjusted pricing shown above. You will be automatially charged the difference between the orginal amount and the new amount you are accepting. Do you want to continue?"
                    close={() => this.setState({ showTermOfUseAlert: false })}
                    handleYes={() => this.setState({ showTermOfUseAlert: false })}
                    handleNo={() => this.setState({ showTermOfUseAlert: false })}
                />
                <AreYouSureAlert
                    open={this.state.show_deactivate_alert}
                    title=""
                    content="You are deativating your account. Do you want to continue?"
                    close={() => this.setState({ show_deactivate_alert: false })}
                    handleYes={this.deactivate}
                    handleNo={() => this.setState({ show_deactivate_alert: false })}
                />
            </HOCLoader>
        );
    }
}

const composedComponent = compose(
    connect(null, actions)
);

export default composedComponent(withUser(BasicCustomerProfile));



// WEBPACK FOOTER //
// ./src/components/Customer/BasicCustomerProfile.jsx